import { render, staticRenderFns } from "./income_analysis.vue?vue&type=template&id=5c88ef0b&"
import script from "./income_analysis.vue?vue&type=script&lang=js&"
export * from "./income_analysis.vue?vue&type=script&lang=js&"
import style0 from "./income_analysis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports